var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar",style:(_vm.avatarStyle)})
}
var staticRenderFns = []

export { render, staticRenderFns }